module.exports = __webpack_public_path__ + "static/media/WorcesterChamberOfCommerceLogo.0dfb36df.png";